const modules = {
	title: "Modules",
};
export default modules;